import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { summervilleConfig } from "./data";

export default function SummervillePage() {
  return <CityPageTemplate config={summervilleConfig} />;
}